// @flow
import type { Styles } from '..'
import * as primary from './primary'

export const Label = (props: Styles) => ({
  ...primary.Label(props),
  color: `${props.$palette('white')}`,
})

export const CheckContainer = (props: Styles) => ({
  ...primary.CheckContainer(props),
  border: `1px solid ${props.$palette('white')}`,
  backgroundColor: props.$checked
    ? `${props.$palette('white')}`
    : `${props.$palette('transparent')}`,
})

export const CheckMark = (props: Styles) => ({
  ...primary.CheckMark(props),
  color: `${props.$palette(props.$color)}`,
})

export const RadioMark = (props: Styles) => ({
  ...primary.RadioMark(props),
  background: `${props.$palette(props.$color)}`,
})
